export default __webpack_public_path__ + "static/media/main_section3.598efc7b.jpg";